// see the main xi repo for the source of truth
export enum EventName {
  $pageview,
  $pageleave,
  $feature_flag_called,

  cookiebot_consent_recorded,
  cookie_banner_audio_played,
  cookie_banner_audio_paused,
  cookie_banner_decline,
  cookie_banner_accept_all,
  cookie_banner_accept_selection,

  website_clicked_omnibox_tab,
  mw_platform_tab_clicked,
  mw_below_omnibox_cta,
  marketing_site_convai_agent_expanded,
  marketing_site_convai_agent_collapsed,
  marketing_site_convai_agent_call_started,
  marketing_site_convai_agent_call_failed,
  marketing_site_convai_agent_call_ended,
  marketing_site_convai_agent_message_sent,

  feathery_form_information_entered,
  feathery_form_submitted,
  calendly_event_scheduled,
  contact_sales_event,
  website_clicked_share_button,
  website_clicked_share_option,
  marketing_website_sound_effects_search,
  marketing_website_interactive_demo_error,
  mw_hcaptcha_script_timeout,
  mw_hcaptcha_challenge_opened,
  mw_hcaptcha_challenge_closed,
  mw_hcaptcha_failed,
  mw_external_redirect_ab_evaluated,

  // Auth (shared with xi repo)
  signed_in,
  sign_up_form_submitted,

  // Auth dialog
  mw_auth_dialog_opened,
  mw_auth_dialog_closed,
  mw_sign_up_google_clicked,
  mw_sign_up_form_error,
  mw_sign_in_google_clicked,
  mw_sign_in_apple_clicked,
  mw_sign_in_form_error,

  // Blog
  mw_table_of_contents_click,
  mw_blog_article_cta_click,

  // music demo
  marketing_website_music_demo_play_sample,
  marketing_website_music_demo_generate,
  marketing_website_music_demo_continue_editing,
  marketing_website_music_demo_quota_exceeded,
  marketing_website_music_demo_error,

  // music hero tabs (A/B test variant)
  mw_music_hero_tab_changed,
  mw_music_hero_sample_played,
  mw_music_hero_sample_paused,
  mw_music_hero_sample_navigated,

  // video to music
  marketing_website_video_to_music_generate,
  marketing_website_video_to_music_studio_redirected,

  mw_tts_customer_type_selected,

  /**
   *
   * Voice Cloning Demo
   *
   */
  mw_voice_cloning_demo_sample_played,

  // Voice Cloning V2 - Tab/view events
  mw_voice_cloning_v2_tab_changed,
  mw_voice_cloning_v2_sample_selected,

  // Voice Cloning V2 - Clone flow events
  mw_voice_cloning_v2_recording_started,
  mw_voice_cloning_v2_recording_stopped,
  mw_voice_cloning_v2_recording_max_duration_reached,
  mw_voice_cloning_v2_file_uploaded,
  mw_voice_cloning_v2_preview_played,
  mw_voice_cloning_v2_restart_clicked,
  mw_voice_cloning_v2_generate_clicked,
  mw_voice_cloning_v2_upload_succeeded,
  mw_voice_cloning_v2_upload_failed,

  /**
   *
   * Voice Changer Demo
   *
   */
  mw_voice_changer_demo_sample_played,

  // Voice Changer V2 - Tab/view events
  mw_voice_changer_v2_tab_changed,
  mw_voice_changer_v2_sample_selected,

  // Voice Changer V2 - Change flow events
  mw_voice_changer_v2_recording_started,
  mw_voice_changer_v2_recording_stopped,
  mw_voice_changer_v2_recording_max_duration_reached,
  mw_voice_changer_v2_file_uploaded,
  mw_voice_changer_v2_file_too_large,
  mw_voice_changer_v2_restart_clicked,
  mw_voice_changer_v2_voice_selected,
  mw_voice_changer_v2_generation_started,
  mw_voice_changer_v2_generation_completed,
  mw_voice_changer_v2_generation_error,
  mw_voice_changer_v2_playback_toggled,

  /**
   *
   * TTS Demo
   *
   */
  mw_tts_dialogue_mode_generation_started,
  mw_tts_dialogue_mode_generation_completed,
  mw_tts_dialogue_mode_generation_error,
  landing_page_tts_audio_generated, // TTS generation_started
  mw_tts_generation_completed, // TTS generation_completed
  mw_tts_generation_error,
  mw_tts_download_clicked,
  mw_tts_limit_shown,
  mw_tts_sample_selected,
  mw_tts_voice_changed,
  mw_tts_prev_next_voices,
  mw_tts_edit_text,
  mw_tts_language_changed,
  mw_tts_model_changed,
  mw_tts_voice_heard, // Audio listened to (preview or generation)
  mw_tts_voice_library_explore_clicked,

  // tts signup popover
  mw_tts_signup_popover_shown,
  mw_tts_signup_popover_closed,
  mw_tts_signup_popover_cta_clicked,

  // stt
  mw_stt_transcribe_file,
  mw_stt_transcribe_file_error,
  mw_stt_transcribe_url,
  mw_stt_transcribe_url_error,
  mw_stt_transcription_download,
  mw_stt_example_clicked,
  mw_stt_example_played,
  mw_stt_realtime_started,
  mw_stt_realtime_session_ended,
  mw_stt_realtime_session_limit_reached,
  mw_stt_realtime_quota_exceeded,
  mw_stt_quota_exceeded,
  mw_stt_realtime_error,

  // voice isolator
  mw_voice_isolator_recording_started,
  mw_voice_isolator_recording_step_reached,
  mw_voice_isolator_recording_stopped,
  mw_voice_isolator_recording_max_duration_reached,
  mw_voice_isolator_file_uploaded,
  mw_voice_isolator_isolation_started,
  mw_voice_isolator_isolation_succeeded,
  mw_voice_isolator_isolation_failed,
  mw_voice_isolator_quota_exceeded,
  mw_voice_isolator_audio_type_selected,
  mw_voice_isolator_playback_toggled,
  mw_voice_isolator_download_clicked,
  mw_voice_isolator_restart_clicked,
  mw_voice_isolator_sign_up_clicked,
  mw_voice_isolator_nudge_shown,
  mw_voice_isolator_nudge_clicked,

  // voice changer nudge
  mw_voice_changer_nudge_shown,
  mw_voice_changer_nudge_clicked,

  // voice cloning nudge
  mw_voice_cloning_nudge_shown,
  mw_voice_cloning_nudge_clicked,

  /**
   *
   * STS / Voice Changer
   *
   */
  mw_sts_recording_started,
  mw_sts_recording_stopped,
  mw_sts_recording_max_duration_reached,
  mw_sts_prompt_completed,
  mw_sts_file_uploaded,
  mw_sts_file_upload_error,
  mw_sts_generation_started,
  mw_sts_generation_completed,
  mw_sts_generation_error,
  mw_sts_voice_selected,
  mw_sts_playback_toggled,
  mw_sts_restart_clicked,

  // Audio Provider (generic audio playback events)
  // Properties: source, audio_id, voice_id, position
  // Audio playback sources:
  // - voices_slider
  // - slider_generate_tts
  // - voice_cloning_demo
  // - voice_changer_demo
  // - voice_isolator_demo
  // - voice_designer_demo
  mw_audio_played,
  mw_audio_paused,
  mw_audio_completed,
  mw_audio_play_error,

  // TTS Full Page
  mw_tts_collection_selected,
  mw_tts_editor_entered,
  mw_tts_input_mode_changed,
  mw_tts_text_extracted,
  mw_tts_suggested_prompt_clicked,
  mw_tts_continue_in_app_clicked,
  mw_tts_signup_cta_clicked,

  // Voices Slider
  mw_voices_slider_cta_clicked,
  mw_tts_voice_slider_switcher,

  // voice library collection pages
  mw_voice_library_edit_prompt_clicked,
  mw_voice_library_open_in_app_clicked,
  mw_voice_library_voice_played,

  // mosaic block
  mw_mosaic_item_clicked,

  // social proof
  mw_social_proof_laurel_clicked,
  mw_body_cta_clicked,

  // hero links
  mw_hero_primary_link,
  mw_hero_secondary_link,
  mw_nav_primary_link,
  mw_nav_secondary_link,

  // banner
  mw_banner_clicked,

  /**
   *
   * Translate Media
   *
   */
  mw_translate_media_file_uploaded, // step 1
  mw_translate_media_generation_started, // step 2
  mw_translate_media_generation_completed, // step 3
  // CTAs
  mw_translate_media_download_clicked,
  mw_translate_media_edit_clicked,
  // limits
  mw_translate_media_limit_shown, // limit_type: "duration" | "quota"
  mw_translate_media_limit_closed,
  mw_translate_media_limit_sign_up_clicked,
  mw_translate_media_generation_error, //

  /**
   *
   * Subtitle Media
   *
   */
  mw_subtitle_media_file_uploaded, // step 1
  mw_subtitle_media_generation_started, // step 2
  mw_subtitle_media_generation_completed, // step 3
  // CTAs
  mw_subtitle_media_download_clicked,
  // limits
  mw_subtitle_media_limit_shown, // limit_type: "duration" | "quota"
  mw_subtitle_media_limit_closed,
  mw_subtitle_media_limit_sign_up_clicked,
  mw_subtitle_media_generation_error, //

  // demos
  mw_limit_reached_overlay_sign_up_clicked,

  // creative template omnibox
  mw_creative_template_omnibox_generation_started,
  mw_creative_template_omnibox_generation_succeeded,
  mw_creative_template_omnibox_generation_failed,
  mw_creative_template_omnibox_quota_exceeded,
  mw_creative_template_omnibox_limit_sign_up_clicked,

  // image hero engagement (MW Image Interactive Hero A/B test) — fired on both the interactive
  // test hero (interactive: true) and the legacy control showcase (interactive: false)
  mw_image_hero_clicked,

  // errors
  mw_browser_permission_error,

  // pricing
  mw_pricing_card_cta_clicked,
  mw_pricing_card_view_more_clicked,
  mw_api_pricing_cta_clicked,
  mw_model_card_cta_clicked,
  mw_external_model_card_clicked,

  // sound effects
  mw_sfx_generation_started,
  mw_sfx_generation_successful,
  mw_sfx_generation_failed,
  mw_sfx_generation_quota_exceeded,
  mw_sfx_generation_played,
  mw_sfx_generation_signup_cta_clicked,
  mw_sfx_generation_suggestion_clicked,

  mw_sfx_edit_prompt_clicked,
  mw_sfx_prompt_used,
  mw_sfx_generate_cta_clicked,

  mw_sfx_download_menu_opened,
  mw_sfx_download_menu_option_clicked,

  mw_sfx_samples,

  mw_sfx_search_result_clicked,
  mw_sfx_suggestion_clicked,
  mw_sfx_similar_category_clicked,

  mw_sfx_signup_popover_shown,
  mw_sfx_signup_popover_cta_clicked,
  mw_sfx_signup_popover_closed,

  mw_sfx_hero_cta_clicked,

  // music categories v2
  mw_music_category_samples,
  mw_music_category_signup_popover_shown,
  mw_music_category_signup_popover_closed,
  mw_music_category_signup_popover_cta_clicked,
  mw_music_category_search_result_clicked,
  mw_music_category_suggestion_clicked,
  mw_music_category_generation_signup_cta_clicked,
  mw_music_category_generation_suggestion_clicked,
  mw_music_category_similar_clicked,
  mw_music_category_generate_cta_clicked,
  mw_music_category_generation_started,
  mw_music_category_generation_successful,
  mw_music_category_generation_failed,
  mw_music_category_generation_quota_exceeded,
  mw_music_category_generation_played,
  mw_music_category_waveform_seeked,
  mw_music_category_hero_cta_clicked,
  mw_music_category_edit_prompt_clicked,
  marketing_website_music_categories_search,

  // contact sales v2
  mw_contact_sales_v2_form_viewed,
  mw_contact_sales_v2_step_completed,
  mw_contact_sales_v2_back_clicked,
  mw_contact_sales_v2_submission_succeeded,
  mw_contact_sales_v2_submission_failed,
  mw_contact_sales_v2_ai_sdr_clicked,
  mw_contact_sales_v2_final_screen_link_clicked,
  mw_contact_sales_v2_start_new_submission_clicked,

  // contact sales feather form
  mw_contact_sales_feathery_load_failed,
  mw_contact_sales_feathery_error,

  // webinar content gate
  mw_webinar_form_submitted,
  mw_webinar_playback_started,
  mw_webinar_playback_ended,

  // event resources
  mw_event_resource_playback_started,
  mw_event_resource_playback_ended,

  // professor impact program
  mw_professor_impact_form_submitted,

  // vc / startup grants
  mw_vc_form_submitted,

  // talent representation
  mw_talent_representation_form_submitted,

  // culture partnership
  mw_culture_partnership_form_submitted,

  // hero agent
  mw_hero_agent_call_agent_clicked,
  mw_hero_agent_get_call_clicked,
  mw_hero_agent_terms_agreed,
  mw_hero_agent_terms_cancelled,
  mw_hero_agent_conversation_started,
  mw_hero_agent_conversation_failed,
  mw_hero_agent_conversation_ended,
  mw_hero_agent_language_changed,
  mw_hero_agent_mute_toggled,
  mw_hero_agent_request_call_submitted,
  mw_hero_agent_request_call_succeeded,
  mw_hero_agent_request_call_failed,
  mw_hero_agent_request_call_cancelled,
  mw_hero_agent_verify_submitted,
  mw_hero_agent_verify_succeeded,
  mw_hero_agent_verify_failed,
  mw_hero_agent_verify_resend_clicked,
  mw_hero_agent_call_scheduled_closed,
  mw_hero_agent_retry_call_requested,
  mw_hero_agent_message_sent,

  // Speech Engine omnibox demo (preview → live voice)
  mw_speech_engine_demo_enable_clicked,
  mw_speech_engine_demo_back_clicked,

  // audio native
  mw_audio_native_play,
  mw_audio_native_pause,
  mw_audio_native_seek,
  mw_audio_native_skip,
  mw_audio_native_speed_change,
  mw_audio_native_unload,
  mw_audio_native_error,

  // ai / markdown
  mw_markdown_requested = "mw_markdown_requested",

  // session recording
  mw_session_recording_started = "mw_session_recording_started",
}

// separate enum to reduce cost of handling all the extra events
// only put very high frequency events here that we don't want to track via posthog/brevo
// such as triggers for tags
export enum GoogleTagManagerOnlyEventName {
  ready_for_pixels,
}
